import hero from "/assets/images/hero.jpeg"

export const heroImg = hero

import hmv from "/assets/videos/hero.mp4"
import smallmv from "/assets/videos/smallHero.mp4"
import highlightFirstmv from "/assets/videos/highlight-first.mp4"
import highlightSectmv from "/assets/videos/hightlight-third.mp4"
import highlightThirdmv from "/assets/videos/hightlight-sec.mp4"
import highlightFourthmv from "/assets/videos/hightlight-fourth.mp4"
import exploremv from "/assets/videos/explore.mp4"
import framemv from "/assets/videos/frame.mp4"

import apple from "/assets/images/apple.svg"
import search from "/assets/images/search.svg"
import bag from "/assets/images/bag.svg"
import burger from "/assets/images/burger-menu.svg"
import x from "/assets/images/x.jpg"
import watch from "/assets/images/watch.svg"
import right from "/assets/images/right.svg"
import replay from "/assets/images/replay.svg"
import play from "/assets/images/play.svg"
import pause from "/assets/images/pause.svg"

import appleWatch from "/assets/images/appleWatchItem.png"
import airPodsItems from "/assets/images/airPods.png"
import appleVisionItem from "/assets/images/appleVisionItem.png"
import ipadItem from "/assets/images/ipadItem.png"
import iphoneItem from "/assets/images/iphoneItem.png"
import macItem from "/assets/images/macItem.png"
import yellow from "/assets/images/yellow.jpg"
import blue from "/assets/images/blue.jpg"
import white from "/assets/images/white.jpg"
import black from "/assets/images/black.jpg"
import explore1 from "/assets/images/explore1.jpg"
import explore2 from "/assets/images/explore2.jpg"
import chip from "/assets/images/chip.jpeg"
import frame from "/assets/images/frame.png"

export const heroVideo = hmv
export const smallHeroVideo = smallmv
export const highlightFirstVideo = highlightFirstmv
export const highlightSecondVideo = highlightSectmv
export const highlightThirdVideo = highlightThirdmv
export const highlightFourthVideo = highlightFourthmv
export const exploreVideo = exploremv
export const frameVideo = framemv

export const appleImg = apple
export const searchImg = search
export const bagImg = bag
export const burgerImg = burger
export const xImg = x
export const watchImg = watch
export const rightImg = right
export const replayImg = replay
export const playImg = play
export const pauseImg = pause

export const appleWatchItemImg = appleWatch
export const airPodsItemsImg = airPodsItems
export const appleVisionItemImg = appleVisionItem
export const ipadItemImg = ipadItem
export const iphoneItemImg = iphoneItem
export const macItemImg = macItem
export const yellowImg = yellow
export const blueImg = blue
export const whiteImg = white
export const blackImg = black
export const explore1Img = explore1
export const explore2Img = explore2
export const chipImg = chip
export const frameImg = frame

import performanceMac from "/assets/videos/performance-mac.mp4"
export const performanceMacVideo = performanceMac

import macFeatures from "/assets/images/mac-features.jpg"
import photoForFeatures1 from "/assets/images/photo-for-features1.png"
import photoForFeatures2 from "/assets/images/photo-for-features2.png"
import photoForFeatures3 from "/assets/images/photo-for-features3.png"
import photoForFeatures4 from "/assets/images/photo-for-features4.png"
import photoForFeatures5 from "/assets/images/photo-for-features5.png"
import photoForFeatures6 from "/assets/images/photo-for-features6.png"

export const macFeaturesImg = macFeatures
export const photoForFeatures1Img = photoForFeatures1
export const photoForFeatures2Img = photoForFeatures2
export const photoForFeatures3Img = photoForFeatures3
export const photoForFeatures4Img = photoForFeatures4
export const photoForFeatures5Img = photoForFeatures5
export const photoForFeatures6Img = photoForFeatures6

import hightLightForMacVideoFirst from "/assets/videos/hightlight-for-mac-video1.mp4"
import hightLightForMacVideoSecond from "/assets/videos/hightlight-for-mac-video2.mp4"
import hightLightForMacVideoFour from "/assets/videos/highlights-for-mac-video4.mp4"
import hightLightForMacVideoThird from "/assets/videos/hightlight-for-mac-video3.mp4"

export const hightLightForMacVideoFirstVideo = hightLightForMacVideoFirst
export const hightLightForMacVideoSecondVideo = hightLightForMacVideoSecond
export const hightLightForMacVideoThirdVideo = hightLightForMacVideoThird
export const hightLightForMacVideoFourthVideo = hightLightForMacVideoFour

import macBookTitleImg from "/assets/images/mac-book-title-img.png"
import macBookLarge from "/assets/videos/macBookLarge.mp4"
import macBookSmall from "/assets/videos/macBookSmallVid.mp4"

export const macBookTitleImgSrc = macBookTitleImg
export const macBookLargeSrc = macBookLarge
export const macBookSmallSrc = macBookSmall

import iPhoneCurImg from "/assets/images/iPhone-card.jpeg"
import iPhoneCurImg2 from "/assets/images/iPhone-card-2.jpeg"
import iPadCurImg from "/assets/images/ipad-card.jpeg"
import iPadCurImg2 from "/assets/images/ipad-card-2.jpeg"
import iPadProCurImg from "/assets/images/ipadPro-card.jpeg"
import macCurImg from "/assets/images/mac-card.jpeg"
import macMiniCurImg from "/assets/images/macMini-card.jpeg"
import watchCurImg from "/assets/images/watch-card.jpeg"
import watchCurImg2 from "/assets/images/watch-card-2.jpeg"
import watchCurImg3 from "/assets/images/watch-card-3.jpeg"

export const iPhoneCurImgSrc = iPhoneCurImg
export const iPhoneCurImg2Src = iPhoneCurImg2
export const iPadCurImgSrc = iPadCurImg
export const iPadCurImg2Src = iPadCurImg2
export const iPadProCurImgSrc = iPadProCurImg
export const macCurImgSrc = macCurImg
export const macMiniCurImgSrc = macMiniCurImg
export const watchCurImgSrc = watchCurImg
export const watchCurImg2Src = watchCurImg2
export const watchCurImg3Src = watchCurImg3

import entImgBig from "/assets/images/ent-img.png"
import entImgSmall from "/assets/images/ent-img-sm.jpg"

export const entImgBigSrc = entImgBig
export const entImgSmallSrc = entImgSmall

import cardPng from "/assets/png/card.png"
import notePng from "/assets/png/note.png"
import screenPng from "/assets/png/screen.png"
import smilePng from "/assets/png/smile.png"
import truckPng from "/assets/png/truck.png"
import watchPng from "/assets/png/watch.png"

export const cardPngSrc = cardPng
export const notePngSrc = notePng
export const screenPngSrc = screenPng
export const smilePngSrc = smilePng
export const truckPngSrc = truckPng
export const watchPngSrc = watchPng
